import { render, staticRenderFns } from "./ArtImportedFrom.vue?vue&type=template&id=367545dd&scoped=true&"
import script from "./ArtImportedFrom.vue?vue&type=script&lang=js&"
export * from "./ArtImportedFrom.vue?vue&type=script&lang=js&"
import style0 from "./ArtImportedFrom.vue?vue&type=style&index=0&id=367545dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367545dd",
  null
  
)

export default component.exports